export enum VtmnPlayButtonVariantStyleEnum {
  REGULAR = 'regular',
  INVERSE = 'inverse',
}
